if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class Header extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.headerGroupElement = this.closest('.shopify-section-group-header-group');
        this.headerHeight = this.headerGroupElement?.scrollHeight;
        this.header = this.closest('.header');
        this.isOverlay = this.dataset.overlay === 'true';
        this.fadeInDone = false;

        this.updateHeaderOffset();
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

        this.header.addEventListener('animationend', (e) => {
          if (e.animationName === 'fadeIn') {
            this.header.classList.remove('animate-fadeIn');
            this.fadeInDone = true;
          }
        });

        if (this.headerGroupElement) {
          new ResizeObserver(() => {
            this.headerHeight = this.headerGroupElement.scrollHeight;
            this.updateHeaderOffset();
            document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
          }).observe(this.headerGroupElement);
        }

        window.addEventListener('resize', () => {
          this.headerHeight = this.headerGroupElement?.scrollHeight;
          this.updateHeaderOffset();
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        });

        window.addEventListener('scroll', () => {
          if (this.isOverlay) {
            this.header.classList.toggle('header--scrolled', window.scrollY > 100);
          }

          if ((window.scrollY > this.lastScroll) && (window.scrollY > (this.headerHeight * 10))) {
            this.header.classList.remove('animate-fadeIn');
            this.header.classList.add('animate-fadeOut');
            this.fadeInDone = false;
            if (this.navDrawerOpen) {
              window.dispatchEvent(new CustomEvent('modal:closeById', { detail: this.navDrawerModalId }));
            }
            this.startOffsetTracking();
          } else if ((window.scrollY < this.lastScroll) || (window.scrollY < (this.headerHeight * 10) && this.classList.contains('animate-fadeOut'))) {
            this.header.classList.remove('animate-fadeOut');
            if (!this.fadeInDone) {
              this.header.classList.add('animate-fadeIn');
            }
            this.startOffsetTracking();
          }

          this.updateHeaderOffset();
          this.lastScroll = window.scrollY;
        }, { passive: true });

        this.setupNavDrawer();
      }

      setupNavDrawer() {
        const shopifySectionElement = this.closest('.shopify-section') ?? this.parentElement;
        const navTemplate = shopifySectionElement?.querySelector('template[data-nav-modal]');
        if (!navTemplate) return;

        this.navDrawerModalId = navTemplate.dataset.modalContent;
        this.navDrawerOpen = false;

        const trigger = this.querySelector('[data-nav-trigger]');
        trigger?.addEventListener('click', () => {
          if (this.navDrawerOpen) {
            window.dispatchEvent(new CustomEvent('modal:closeById', { detail: this.navDrawerModalId }));
          } else {
            this.updateHeaderOffset();
            window.dispatchEvent(new CustomEvent('modal:openById', { detail: this.navDrawerModalId }));
          }
        });

        const customModal = document.querySelector('custom-modal');
        if (customModal) {
          new MutationObserver(() => {
            this.navDrawerOpen = !!customModal.querySelector(`[data-modal-content="${this.navDrawerModalId}"]:not(template)`);
            this.toggleAttribute('data-nav-open', this.navDrawerOpen);
            trigger?.setAttribute('aria-expanded', this.navDrawerOpen ? 'true' : 'false');

            if (this.navDrawerOpen) {
              this._mountTriggerPortal(trigger);
            } else {
              this._removeTriggerPortal();
            }
          }).observe(customModal, { childList: true });
        }
      }

      _mountTriggerPortal(trigger) {
        this._removeTriggerPortal();
        const rect = trigger.getBoundingClientRect();
        const clone = trigger.cloneNode(true);
        clone.dataset.navTriggerPortal = '';
        clone.style.cssText = `
          position: fixed;
          top: ${rect.top}px;
          left: ${rect.left}px;
          width: ${rect.width}px;
          height: ${rect.height}px;
          z-index: 60;
          color: var(--color-primary-dark);
          display: flex;
          align-items: center;
        `;
        clone.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('modal:closeById', { detail: this.navDrawerModalId }));
        });
        const iconSpan = clone.querySelector('[aria-hidden="true"]');
        if (iconSpan) iconSpan.style.transform = 'rotate(45deg)';
        document.body.appendChild(clone);
        this._triggerPortal = clone;
      }

      _removeTriggerPortal() {
        this._triggerPortal?.remove();
        this._triggerPortal = null;
      }

      startOffsetTracking() {
        if (this._trackingRaf) return;
        const track = () => {
          this.updateHeaderOffset();
          if (this.header.classList.contains('animate-fadeIn') || this.header.classList.contains('animate-fadeOut')) {
            this._trackingRaf = requestAnimationFrame(track);
          } else {
            this._trackingRaf = null;
            this.updateHeaderOffset();
          }
        };
        this._trackingRaf = requestAnimationFrame(track);
      }

      updateHeaderOffset() {
        document.documentElement.style.setProperty('--header-offset', `${Math.max(this.header.getBoundingClientRect().bottom, 0)}px`);
      }
    }
  );
}
